import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { UnavailabilityError } from '@unimodules/core';
import { PermissionStatus } from 'unimodules-permissions-interface';
import ExponentImagePicker from "./ExponentImagePicker";
import { MediaTypeOptions, VideoExportPreset } from "./ImagePicker.types";
export function getCameraPermissionsAsync() {
  return _regeneratorRuntime.async(function getCameraPermissionsAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ExponentImagePicker.getCameraPermissionsAsync());

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function getCameraRollPermissionsAsync() {
  return _regeneratorRuntime.async(function getCameraRollPermissionsAsync$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", ExponentImagePicker.getCameraRollPermissionsAsync());

        case 1:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, null, Promise);
}
export function requestCameraPermissionsAsync() {
  return _regeneratorRuntime.async(function requestCameraPermissionsAsync$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", ExponentImagePicker.requestCameraPermissionsAsync());

        case 1:
        case "end":
          return _context3.stop();
      }
    }
  }, null, null, null, Promise);
}
export function requestCameraRollPermissionsAsync() {
  return _regeneratorRuntime.async(function requestCameraRollPermissionsAsync$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", ExponentImagePicker.requestCameraRollPermissionsAsync());

        case 1:
        case "end":
          return _context4.stop();
      }
    }
  }, null, null, null, Promise);
}
export function launchImageLibraryAsync() {
  var options,
      _args5 = arguments;
  return _regeneratorRuntime.async(function launchImageLibraryAsync$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};

          if (ExponentImagePicker.launchImageLibraryAsync) {
            _context5.next = 3;
            break;
          }

          throw new UnavailabilityError('ImagePicker', 'launchImageLibraryAsync');

        case 3:
          _context5.next = 5;
          return _regeneratorRuntime.awrap(ExponentImagePicker.launchImageLibraryAsync(options));

        case 5:
          return _context5.abrupt("return", _context5.sent);

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, null, null, null, Promise);
}
export function launchCameraAsync() {
  var options,
      _args6 = arguments;
  return _regeneratorRuntime.async(function launchCameraAsync$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          options = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};

          if (ExponentImagePicker.launchCameraAsync) {
            _context6.next = 3;
            break;
          }

          throw new UnavailabilityError('ImagePicker', 'launchCameraAsync');

        case 3:
          _context6.next = 5;
          return _regeneratorRuntime.awrap(ExponentImagePicker.launchCameraAsync(options));

        case 5:
          return _context6.abrupt("return", _context6.sent);

        case 6:
        case "end":
          return _context6.stop();
      }
    }
  }, null, null, null, Promise);
}
export { MediaTypeOptions, VideoExportPreset, PermissionStatus };